import React, {Component} from "react"
import Column from "@amzn/meridian/column";
import LidarContextProvider from "./context/LidarContextProvider";
import TabLayout, {NavigationRoutes} from "../../util/TabLayout";
import {LIDARS} from "../../util/RouteConstants";

/**
 * Returns the page heading and description
 * @return JSX.Element
 * @param props
 */

class LidarPage extends Component {
    render() {
        return (
            <Column>
                <LidarContextProvider>
                    <TabLayout routes={LIDARS} location={this.props.location} history={this.props.history}/>
                    <NavigationRoutes routes={LIDARS}/>
                </LidarContextProvider>
            </Column>
        )
    }
}

export default LidarPage;



// WEBPACK FOOTER //
// ./src/components/devicemanagement/lidar/LidarPage.js